import { render } from "./FormUserRole.vue?vue&type=template&id=06ed6622"
import script from "./FormUserRole.vue?vue&type=script&lang=js"
export * from "./FormUserRole.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__